import { NgModule } from '@angular/core';

import { SharedLibsModule } from './shared-libs.module';
import { PreviousRouteService } from './services/previousRoute/previousRoute.service';
import { AlertComponent } from './components/alert/alert.component';
import { AlertErrorComponent } from './components/alert/alert-error.component';
import { HasAnyAuthorityDirective } from './directives/auth/has-any-authority.directive';
import { FormatMediumDatetimePipe } from './pipes/date/format-medium-datetime.pipe';
import { FormatMediumDatePipe } from './pipes/date/format-medium-date.pipe';
import { SortByDirective } from './directives/sort/sort-by.directive';
import { SortDirective } from './directives/sort/sort.directive';
import { ItemCountComponent } from './components/pagination/item-count.component';
import { FilterComponent } from './components/filter/filter.component';
import { TranslateDirective } from './directives/language/translate.directive';
import { HiddenDirective } from './directives/hidden/hidden.directive';
import { SharedLibsInternalModule } from './shared-libs-internal.module';
import { StatusSelectComponent } from '../modules/admin/status/select/status-select.component';

@NgModule({
	imports: [SharedLibsModule, SharedLibsInternalModule],
	declarations: [
		//Pipes
		FormatMediumDatetimePipe,
		FormatMediumDatePipe,
		//Directives
		TranslateDirective,
		HasAnyAuthorityDirective,
		SortByDirective,
		HiddenDirective,
		SortDirective,
		//Components
		AlertComponent,
		AlertErrorComponent,
		ItemCountComponent,
		FilterComponent,
		StatusSelectComponent,
	],
	exports: [
		SharedLibsModule,
		SharedLibsInternalModule,
		//Pipes
		FormatMediumDatetimePipe,
		FormatMediumDatePipe,
		//Directives
		TranslateDirective,
		HasAnyAuthorityDirective,
		SortByDirective,
		HiddenDirective,
		SortDirective,
		//Components
		AlertComponent,
		AlertErrorComponent,
		ItemCountComponent,
		FilterComponent,
		StatusSelectComponent,
	],
	providers: [PreviousRouteService],
})
export class SharedModule {}
